<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-dialog
        v-model="dialog"
        scrollable  
        persistent
        max-width="750px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Mentor Information for {{viewedItem.name}} </span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <div 
                    class="text-xs-left">
                    <span class="v-label theme--light">
                      {{viewedItem.available}} to take on clients<br><br>
                    </span>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.email"
                    readonly
                    hide-details
                    label="Email"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.telephone" 
                    readonly
                    hide-details
                    label="Telephone"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="viewedItem.location" 
                    readonly
                    hide-details
                    label="Location"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="viewedItem.employer" 
                    readonly
                    hide-details
                    label="Employer"></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field 
                    v-model="viewedItem.clientsLimit" 
                    readonly
                    hide-details
                    label="Limit of Concurrent Clients"></v-text-field>
                </v-flex>
                <v-flex xs4 offset-xs2>
                  <v-text-field 
                    v-model="viewedItem.clientsCurrent" 
                    readonly
                    hide-details
                    label="Number of Current Clients"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="viewedItem.role" 
                    readonly
                    hide-details
                    label="Role"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="viewedItem.specialty" 
                    readonly
                    hide-details
                    label="Specialty"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="viewedItem.topics" 
                    readonly
                    hide-details
                    label="Topics"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea 
                    auto-grow
                    rows="1"
                    v-model="viewedItem.bio" 
                    readonly
                    hide-details
                    label="Background"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title class="title">
            Mentor Admin
            </v-toolbar-title>
          </v-toolbar>
          
          <v-card-title>
            Mentor Search
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="mentors"
            :search="search"
            :loading="mentorsLoading"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.location }}</td>
              <td class="text-xs-center">
                <v-icon
                  v-if="props.item.authorised"
                  color="primary"
                >
                  check
                </v-icon>
                <v-icon
                  v-else
                  color="secondary"
                >
                  close
                </v-icon>
              </td>
              <td class="text-xs-left">
                <span v-if="props.item.admin">
                  Yes
                </span>
                <span v-else> </span>
              </td>
              <td class="justify-center layout px-0">
                <v-tooltip left>
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="viewItem(props.item)"
                  >
                    visibility
                  </v-icon>
                  <span>View mentor details</span>  
                </v-tooltip>
                <v-tooltip right v-if="props.item.authorised == false">
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    color="green"
                    @click="changeUserAuth(props.item)"
                  >
                    check_circle
                  </v-icon>
                  <span>Authorise Mentor</span>  
                </v-tooltip>
                <v-tooltip right v-else>
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    color="red"
                    @click="changeUserAuth(props.item)"
                  >
                    highlight_off
                  </v-icon>
                  <span>Disable Mentor</span>  
                </v-tooltip>
                <v-tooltip right>
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    color="nihrGrey"
                    @click="switchAdmin(props.item)"
                  >
                    build
                  </v-icon>
                  <span>Switch Admin on/off</span>  
                </v-tooltip>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-card>

      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      search: '',
      dialog: false,
      headers: [
        { text: 'Mentor', value: 'name'},
        { text: 'Location', value: 'location'},
        { text: 'Authorised', value: 'authorised',align: 'center'},
        { text: 'Admin', value: 'admin'},
      ],
      viewedIndex: -1,
      viewedItem: {},
      defaultItem: {}
    }),
    created: function() {
      this.$store.dispatch("updateMentors")
    },
    computed: {
      mentors: function() {
        return this.$store.getters.getAllMentors
      },
      myProfile: function() {
        return this.$store.getters.getMyProfile
      },
      configData: function () {
        //return this.$store.getters.getForms
        return this.$store.getters.getConfig
      },
      mentorsLoading: function () {
        return this.$store.getters.getMentorLoading
      }
    },
    methods: {
      viewItem (item) {
        console.log("mentorAdmin - selected item: ",item)
        this.viewedIndex = this.mentors.indexOf(item)
        this.viewedItem = Object.assign({}, item)
        this.dialog = true
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.viewedItem = Object.assign({}, this.defaultItem)
          this.viewedIndex = -1
        }, 300)
      },
      changeUserAuth (item) {
        console.log("mentorAdmin - selected item: ",item)
        //this.viewedIndex = this.mentors.indexOf(item)
        //this.viewedItem = Object.assign({}, item)
        var authUpdate = {}
        authUpdate.email = item.email
        authUpdate.authorised = !item.authorised
        console.log("mentorAdmin - update item: ",authUpdate)

        this.$store.dispatch("saveAuthChange",authUpdate)

      },
      switchAdmin (item) {
        console.log("mentorAdmin - selected item: ",item)
        //this.viewedIndex = this.mentors.indexOf(item)
        //this.viewedItem = Object.assign({}, item)
        var authUpdate = {}
        authUpdate.email = item.email
        authUpdate.admin = !item.admin
        console.log("mentorAdmin - admin switched: ",authUpdate)

        this.$store.dispatch("saveAuthChange",authUpdate)

      }
    }
  }
</script>

<style>

</style>
